import { ohlcEndpoint, ohlcRangeEndpoint, studyDataRangeUrl } from "../constant/constants";
import { StudyTypeEnum } from "../enum/studyType";
import { TimeLevelEnum } from "../enum/timelevel";
import { OHLCDataResponse, StudyDataResponse } from "../interface/httpResponse";

//($ as any).Helpers = {
    //AddAntiForgeryToken: (data: any) => data
//};

export const getNavigatorOHLCData = (marketId: string, timelevel: TimeLevelEnum, endDate: string, startDate: string, autoAdjust: boolean, currency: string, electedReversals: boolean = false): Promise<OHLCDataResponse> => {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: ohlcEndpoint,
            data: ($ as any).Helpers.AddAntiForgeryToken({ MarketId: marketId, TimeLevel: timelevel, EndDate: endDate, StartDate: startDate, autoAdjustTimeLevels: autoAdjust, currency: currency, electedReversals }),
        }).done(resolve).fail(reject);
    });
}

export const getOHLCData = (marketId: string, timelevel: TimeLevelEnum, endDate: number, startDate: number, autoAdjust: boolean, currency: string, timeUnitValue: number): Promise<OHLCDataResponse> => {
    return new Promise((resolve, reject) => {
        var dataUrl = ohlcRangeEndpoint + "?marketId=" + marketId + "&timeFrame=" + timelevel + "&startInd=" + startDate + "&endInd=" + endDate + "&autoAdjustTimeLevels=" + autoAdjust + "&currency=" + currency + "&timeUnitValue=" + timeUnitValue;
        $.getJSON(dataUrl, (data: any) => {
            resolve(data);
        });
    });
}

export const getStudyData = (marketId: string, timelevel: TimeLevelEnum, studyStype: StudyTypeEnum, endDate: number, startDate: number, autoAdjust: boolean): Promise<StudyDataResponse> => {
    return new Promise((resolve, reject) => {
        var dataUrl = studyDataRangeUrl + "?marketId=" + marketId + "&timeFrame=" + timelevel + '&startInd=' + startDate + '&endInd=' + endDate + '&studyType=' + studyStype + '&autoAdjustTimeLevels=' + autoAdjust;
        $.getJSON((dataUrl), function (data) {
            resolve(data);
        });
    });
}